/// <reference lib="dom" />
/**
 * One step back through the browser history -- the MFE router's `back` (`./next-navigation-shim.ts`) and every control
 * that leaves a surface the way the user arrived (the payments close button, the auction notice's explore action).
 *
 * A FUNCTION, NOT `window.history.back` PASSED BARE: the method needs `history` as its receiver, and an unbound
 * reference throws an illegal-invocation the moment a click handler calls it.
 */
export function historyBack(): void {
	window.history.back();
}
